<template>
  <div class="max-w-2xl mx-auto p-6">
    <h1 class="text-2xl font-bold mb-4">Sign in</h1>

    <form @submit.prevent="handleSubmit" class="space-y-4">
      <div v-if="step === 'start'">
        <label class="block text-sm mb-1">Email</label>
        <input
          v-model="email"
          type="email"
          required
          placeholder="you@example.com"
          class="w-full p-2 border rounded"
        />
        <button
          type="submit"
          :disabled="loading || !email"
          :class="{'bg-gray-300 cursor-not-allowed': loading || !email, 'bg-blue-600': !loading && email}"
          class="text-white px-4 py-2 rounded mt-2 w-full"
        >
          {{ loading ? 'Sending…' : 'Sign In' }}
        </button>
      </div>

      <div v-else>
        <label class="block text-sm mb-1">Confirmation Code</label>
        <input
          v-model="code"
          type="text"
          inputmode="numeric"
          required
          placeholder="Enter code"
          class="w-full p-2 border rounded"
        />
        <div class="flex gap-2 mt-2">
          <button
            type="submit"
            :disabled="loading || !code"
            :class="{'bg-gray-300 cursor-not-allowed': loading || !code, 'bg-blue-600': !loading && code}"
            class="text-white px-4 py-2 rounded flex-1"
          >
            {{ loading ? 'Confirming…' : 'Confirm' }}
          </button>
          <button type="button" @click="backToEmail" class="px-4 py-2 border rounded text-sm">
            Back
          </button>
        </div>
      </div>

      <p v-if="error" class="text-red-600 mt-2">{{ error }}</p>
    </form>

    <!-- Add agreement line with links -->
    <div class="text-xs text-gray-500 mt-3">
      By using this service you agree to the
    <!-- Add target="_blank" and rel="noopener noreferrer" to each <router-link> so they open in a new tab -->
      <router-link to="/terms" target="_blank" and rel="noopener noreferrer" class="text-blue-600 underline">Terms of Service</router-link>
      and
      <router-link to="/privacy" target="_blank" and rel="noopener noreferrer" class="text-blue-600 underline">Privacy Policy</router-link>.
    </div>

  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { api } from '../api/api'
import { store } from '../stores/userStore';

const router = useRouter()

const email = ref('')
const code = ref('')
const session = ref('')
const step = ref('start') // 'start' | 'confirm'
const loading = ref(false)
const error = ref('')

function backToEmail() {
  step.value = 'start'
  code.value = ''
  error.value = ''
  session.value = ''
}

function saveAuthResult(authResult) {
  if (!authResult) return false
  try {
    localStorage.setItem('accessToken', authResult.AccessToken)
    localStorage.setItem('idToken', authResult.IdToken)
            // Set token expiration (default Cognito access token expires in 1 hour)
        const expirationTime = new Date().getTime() + (authResult.expires_in * 1000);
        localStorage.setItem('tokenExpiration', expirationTime);
    if (authResult.RefreshToken) {
      localStorage.setItem('refreshToken', authResult.RefreshToken)
    }
    return true
  } catch (e) {
    console.error('Failed to save tokens', e)
    return false
  }
}

async function handleSubmit() {
  error.value = ''
  loading.value = true

  try {
    if (step.value === 'start') {
      const res = await api.apiQuery('POST', '/public/CustomOTPLogin', { email: email.value })
      if (res?.status === 'confirm') {
        step.value = 'confirm'
        session.value = res.cognitoResponse.Session
      } else if (res?.status === 'success') {
        const authResult = res?.cognitoResponse?.AuthenticationResult
        if (saveAuthResult(authResult)) {




        } else {
          error.value = 'Authentication succeeded but no tokens returned'
        }
      } else {
        error.value = res?.message || 'Unexpected response from server'
      }
    } else {
      // confirm step
      const payload = { email: email.value, code: code.value }
      if (session.value) payload.session = session.value

      const res = await api.apiQuery('POST', '/public/CustomOTPLogin', payload)

      if (res?.status === 'success') {
        const authResult = res?.cognitoResponse?.AuthenticationResult
        if (saveAuthResult(authResult)) {
          // save the user
          console.log('saving res.user', res.user);
          localStorage.setItem('user', JSON.stringify(res.user))
          console.log('logged in, user:', res.user);
          store.isAuthenticated = true;
          store.showSignInModal = false;  // Close the sign-in modal
        } else {
          error.value = 'Authentication succeeded but no tokens returned'
        }
      } else if (res?.status === 'confirm') {
        step.value = 'confirm'
        session.value = res?.params?.session ?? res?.cognitoResponse?.Session ?? session.value
      } else {
        error.value = res?.message || 'Invalid confirmation code'
      }
    }
  } catch (err) {
    console.error(err)
    error.value = err?.message || 'Request failed'
  } finally {
    loading.value = false
  }
}
</script>